<template>
  <div class="c-required">
    <header class="c-login__header">
      <a class="c-login__header__title">
        <img
          class="c-login__header__title__icon"
          src="/mc/assets/img/login/logo.png"
          alt="logo"
        />
        <img
          class="c-login__header__title__text"
          src="/mc/assets/img/login/logo-title-text.png"
          alt="logo__text"
        />
      </a>
    </header>

    <div class="c-required__main">
      <div class="c-required__content">
        <h3 class="section-title green-left-head">メールアドレス登録</h3>
        <div v-if="status == 'edit'">
          <div class="faq-wrapper">
            <h4 class="faq-cate section-title">
              ご利用に当たってはメールアドレスの登録が必要です。<br />
              下記手順に従ってご登録ください。
            </h4>

            <ul class="stepList">
              <li>
                1. メールアドレスを入力します。
              </li>
              <li>
                2.
                プライバシーポリシーに同意いただき「登録」ボタンをクリックします。
              </li>
              <li>
                3.
                登録したメールアドレスに届く「メールアドレス登録認証URL」をクリックして登録完了です。
              </li>
            </ul>
          </div>
          <div class="mainContent-form">
            <dl class="formTable">
              <dt class="formTable_ttl">
                <span class="icoForm-requir">必須</span>
                <label for="">メールアドレス</label>
              </dt>
              <dd class="formTable_data">
                <div class="formTableBox">
                  <div class="formTableBox_itemBox">
                    <label id="">
                      <input
                        type="text"
                        id=""
                        class="u-input--w100p u-ime-en"
                        maxlength="128"
                        name=""
                        v-model.trim="$v.values.email.$model"
                      />
                    </label>
                  </div>
                  <div class="error" v-if="!$v.values.email.required">
                    必須です
                  </div>
                  <div class="error" v-if="!$v.values.email.email">
                    Emailアドレスを入力してください
                  </div>
                </div>
              </dd>
            </dl>

            <!--//
          <dl class="formTable">
            <dt class="formTable_ttl">
              <span class="icoForm-requir">必須</span>
              <label>更新の通知を受け取る</label>
            </dt>

            <dd class="formTable_data">
              <div class="formTableBox">
                <div class="formTableBox_itemBox">
                  <label>
//-->

            <input
              type="hidden"
              id="notice"
              class=""
              name="notice"
              value="true"
              v-model="values.needToSendEmail"
            />

            <!--//
                    <input
                      type="radio"
                      id="notice"
                      class=""
                      name="notice"
                      value="true"
                      v-model="values.needToSendEmail"
                    />
                    &nbsp;受け取る&nbsp;</label
                  ><label>
                    <input
                      type="radio"
                      id="notice"
                      class=""
                      name="notice"
                      value="false"
                      v-model="values.needToSendEmail"
                    />
                    &nbsp;受け取らない&nbsp;</label
                  >
                </div>
                <div class="error">必須です</div>
                <div class="error">
                  更新の通知を受け取るか選択してください。
                </div>
              </div>
            </dd>
          </dl>
//-->
          </div>

          <div class="kiyakuBox">
            <h3 class="section-title green-left-head">利用規約</h3>
            <br />
            <div class="kiyakuBixInner">
              <div class="kiyaku-wrapper" id="kiyakuLoad"></div>
            </div>
          </div>

          <div class="ppBox">
            <!-- <h4>各社のプライバシーポリシーを確認ください。</h4> -->
            <h4>プライバシーポリシーを確認ください。</h4>
            <ul class="ppList">
              <li>
                <a
                  href="https://www.hoosiers.co.jp/privacypolicy/"
                  target="_blank"
                  >プライバシーポリシー</a
                >
              </li>
            </ul>
          </div>

          <div class="reqCaption">
            <span class="reqCaption"
              ><input
                type="checkbox"
                name="check"
                id="check"
                v-model.trim="$v.values.confirm.$model"
                @change="$v.values.confirm.$touch()"/><label for="check"
                >プライバシーポリシーに同意する</label
              ><br
            /></span>

            <div class="error" v-if="!$v.values.confirm.sameAs">
              同意が必要です
            </div>
          </div>

          <div class="c-required__buttonWrap">
            <a href="javascript:void(0);" @click="onPost">
              <div class="c-required__button">登録</div>
            </a>
          </div>
          <div class="logoutTrg">
            <a href="/logout" class="c-required__buttonWrap">
              <div class="c-required__button">キャンセル</div>
            </a>
          </div>
        </div>
        <div class="faq-wrapper" v-else-if="status == 'complete'">
          <span
            ><span class="caution-em"
              >メールアドレス登録はまだ完了していません。</span
            ><br />
            登録したメールアドレスに届く「メールアドレス登録認証URL」をクリックして登録完了となりますので、メールをご確認ください。<br /><br /><a
              href="/mc/docs/faq.html"
              target="_blank"
              style="text-decoration: underline;"
              >→メールが届かない場合はこちらをご確認ください。</a
            ></span
          >
          <br /><br />
          <div class="c-required__buttonWrap">
            <a href="/logout">
              <div class="c-required__button">ログイン画面へ</div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <footer class="c-required__footer">
      <nav>
        <ul class="c-required__footer__nav">
          <li>
            <a href="https://www.hoosiers.co.jp/privacypolicy/" target="_blank"
              >プライバシーポリシー</a
            >
          </li>
          <li>
            <a href="/mc/docs/kiyaku.html" target="_blank">利用規約</a>
          </li>
        </ul>
      </nav>
      <p class="c-required__footer__copyrights">
        © Hoosiers Holdings Co., Ltd. ALL RIGHTS RESERVED.
      </p>
    </footer>
  </div>
</template>

<script>
import { required, email, sameAs } from "vuelidate/lib/validators";
import UserService from "../../services/user.service";
export default {
  data() {
    return {
      values: {
        email: "",
        confirm: false,
        needToSendEmail: true,
      },
      status: "edit",
    };
  },
  validations: {
    values: {
      email: {
        required,
        email,
      },
      confirm: {
        sameAs: sameAs(() => true),
      },
      needToSendEmail: {
        required,
      },
    },
  },
  async mounted() {
    await this.$nextTick();
    this.contentsLoader("kiyakuLoad", "/mc/docs/kiyaku_pre.html");
  },
  methods: {
    async onPost() {
      console.log("++++ onPost");
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("ERROR");
      } else {
        console.log("OK");
        try {
          const result = await UserService.preVerifyEmail(
            this.values.email,
            this.currentUser.loginID,
          );
          console.log(result);
          const res2 = await UserService.update(this.currentUser._id, {
            needToSendEmail: this.values.needToSendEmail,
          });
          console.log(res2);
          this.status = "complete";
          console.log("ok");
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>

<style></style>
